export default "__VITE_ASSET__BzFsD3$X__"